export default __webpack_public_path__ + "source-sans-pro-v11-latin-600italic-dd140b83074e38c3900c4e2a011113c4.bundle.woff2";